module.exports = __webpack_public_path__ + "img/icono_reloj.9decb943.png";